import { useEffect, useState } from 'react'

import classes from './OrderStatsItem.module.sass'
import { Filters } from './filters/Filters'
import { Totals } from './totals/Totals'
import { ByStatus } from './byStatus/ByStatus'
import { Stats } from './stats/Stats'
import { ClusterInterface, MetricsDetailed } from '../../../../common/types/interfaces'
import { useOrderStatsItem } from './hooks/useOrderStatsItem'
import { getSalesApi } from '../../../../salesApi/salesApi'

type Props = {
  cluster: ClusterInterface
}

export const OrderStatsItem = ({ cluster }: Props) => {
  const { preset, changePreset, range, onRangeChange, data, loading } = useOrderStatsItem(cluster)
  const [metrics, setMetrics] = useState<MetricsDetailed | null>(null)
  const salesApi = getSalesApi()

  useEffect(() => {
    if (!cluster.domain) return
    let cancelled = false
    salesApi.getMetricsDetailed(cluster.domain).then((m) => {
      if (!cancelled) setMetrics(m ?? null)
    })
    return () => {
      cancelled = true
    }
  }, [cluster.domain])

  return (
    <div className={classes.card}>
      <div className={classes.header}>
        <div className={classes.name}>{cluster.name}</div>
      </div>

      <Stats metrics={metrics} />

      <Filters
        preset={preset}
        changePreset={changePreset}
        range={range}
        onRangeChange={onRangeChange}
      />

      <Totals
        totals={loading ? null : (data?.totals ?? null)}
        bonuses={loading ? null : (data?.bonuses ?? null)}
      />
      <ByStatus rows={loading ? [] : (data?.byStatus ?? [])} />
    </div>
  )
}
